import { useEffect, useState } from 'react';
import styles from './style.module.css';
import { Markup } from 'interweave';
import { HelmetComponent } from '../../components/Helmet';
import { api } from '../../server/api';
import { useAuth } from '../../hooks/useAuth';
import { List, ListItem } from '../../components/List';
import Modal from 'react-responsive-modal';
import OnboardingSection from './components/OnboardingSection';
import { ButtonBack } from '../../components/ButtonBack';

export function Infos() {
  const { client, player } = useAuth();
  const [itemActive, setItemActive] = useState(1);
  const [termsContent, setTermsContent] = useState<string>();
  const [termsContentSegmentation, setTermsContentSegmentation] =
    useState<string>();
  const [faqHeaderMessage, setFaqHeaderMessage] = useState<
    string | undefined
  >();
  const [titleHeadFaqMessage, setTitleHeadFaqMessage] = useState<
    string | undefined
  >();
  const [faqQuestions, setFaqQuestions] = useState<Array<object>>();
  const [isFaqHeader, setIsFaqHeader] = useState<boolean>();
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [useTutorial, setUseTutorial] = useState<boolean>(false);
  const [isActiveSegmentationFaq, setIsActiveSegmentationFaq] =
    useState<boolean>(false);
  const [isActiveSegmentationTerms, setIsActiveSegmentationTerms] =
    useState<boolean>(false);

  useEffect(() => {
    console.log(player);

    getClientFaq();
  }, []);

  const getClientTerms = async () => {
    try {
      const parameters = {
        searchFunctionality: 'getClientTerms',
        userType: 'player',
        clientId: client && client.id,
      };

      const responseClientTerms = await api.post('/search', parameters);

      console.log(responseClientTerms);

      const { data } = responseClientTerms;
      if (data.success) {
        setTermsContent(data.data.htmlString ? data.data.htmlString : '');
        setIsActiveSegmentationTerms(eval(data.data.isActiveSegmentationTerms));
        setTermsContentSegmentation(data.data.htmlStringSegmentation);
      }
    } catch (error) {
      console.log('error getClientTerms-->', error);
    }
  };

  const getClientFaq = async () => {
    try {
      const parameters = {
        searchFunctionality: 'getText',
        userType: 'player',
        clientId: client && client.id,
      };

      const responseClientTerms = await api.post('/search', parameters);

      const { data } = responseClientTerms;
      if (data.success) {
        setFaqQuestions(data.data.texts.faq.questions);
        setIsFaqHeader(
          data.data.texts.faq.headerFaq.confirmHeaderFaq === 'true'
            ? true
            : false
        );
        setFaqHeaderMessage(data.data.texts.faq.headerFaq.messageFaq);
        setTitleHeadFaqMessage(data.data.texts.faq.headerFaq.titleFaq);
        setIsActiveSegmentationFaq(
          eval(data.data.texts.faq.headerFaq.isActiveSegmentationFaq)
        );
      }
    } catch (error) {
      console.log('error getClientFaq-->', error);
    }
  };

  const getClientHowItWorks = async () => {
    try {
      const parameters = {
        searchFunctionality: 'getText',
        userType: 'player',
        clientId: client && client.id,
      };

      const responseClientTerms = await api.post('/search', parameters);

      const { data } = responseClientTerms;

      if (data.success) {
        setUseTutorial(client.useTutorial === 'true' ? true : false);
      }
    } catch (error) {
      console.log('error getClientHowItWorks-->', error);
    }
  };

  const renderFaq = () => {
    return (
      <>
        <div className="my-3">
          {isFaqHeader && (
            <>
              <p className="text-center fw-semibold fs-3">
                {titleHeadFaqMessage}
              </p>
              <p className="text-center">{faqHeaderMessage}</p>
            </>
          )}
          {isActiveSegmentationFaq && (
            <List>
              {faqQuestions &&
                faqQuestions.map((question: any, index) => (
                  <>
                    {player &&
                      question.segmentation &&
                      question.segmentation === player.regional && (
                        <ListItem
                          icon="help_outline"
                          key={index}
                          content={question.question}
                          expansible={true}
                          contentExpansible={
                            <Markup content={question.answer} />
                          }
                        />
                      )}
                  </>
                ))}
            </List>
          )}
          {isActiveSegmentationFaq && (
            <List>
              {faqQuestions &&
                faqQuestions.map((question: any, index) => (
                  <>
                    {console.log(question.segmentation)}
                    {player && question.segmentation === '' && (
                      <ListItem
                        icon="help_outline"
                        key={index}
                        content={question.question}
                        expansible={true}
                        contentExpansible={<Markup content={question.answer} />}
                      />
                    )}
                  </>
                ))}
            </List>
          )}
          {!isActiveSegmentationFaq && (
            <List>
              {faqQuestions &&
                faqQuestions.map((question: any, index) => (
                  <ListItem
                    icon="help_outline"
                    key={index}
                    content={question.question}
                    expansible={true}
                    contentExpansible={<Markup content={question.answer} />}
                  />
                ))}
            </List>
          )}
        </div>
      </>
    );
  };

  const renderHowItWorks = () => {
    console.log('tutorial ativo', useTutorial);
    return (
      <>
        {/* {!useTutorial && (
          <div className="my-3">
            {howItWorksImage && (
              <div className="mb-3">
                <img
                  src={howItWorksImage}
                  className="img-fluid rounded"
                  alt=""
                />
              </div>
            )}
            <Markup content={howItWorksContent} />
          </div>
        )}
        {useTutorial && <OnboardingSection />} */}
        <OnboardingSection />
      </>
    );
  };

  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  return (
    <>
      <HelmetComponent
        clientLogoURL={client?.logoURL}
        companyName={client?.companyName}
        clientFavicon={client?.favIcon}
        primaryColor={client?.primaryColor}
        secondaryColor={client?.secondaryColor}
        tabTitle={'Informações'}
      />

      <div className="row">
        <div className="my-3">
          <ButtonBack title="Informações" />
        </div>
      </div>
      <div className="my-3">
        {/* Menu de opções */}
        <div className="row">
          <div className="col-sm-12 col-md-3">
            <div
              className={`p-3 mb-3 ${styles.tabItem} ${
                itemActive === 1 ? styles.active : ''
              }`}
              onClick={() => {
                setItemActive(1);
                getClientFaq();
              }}
            >
              <div className="d-flex align-items-center justify-content-center">
                <i className="material-icons-outlined fs-5 me-3 color-text">
                  sms_failed
                </i>
                <span>Faq</span>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div
              className={`p-3 mb-3 ${styles.tabItem} ${
                itemActive === 2 ? styles.active : ''
              }`}
              onClick={() => {
                setItemActive(2);
                getClientTerms();
              }}
            >
              <div className="d-flex align-items-center justify-content-center">
                <i className="material-icons-outlined fs-5 me-3 color-text">
                  assignment
                </i>
                <span>Termos</span>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div
              className={`p-3 mb-3 ${styles.tabItem} ${
                itemActive === 3 ? styles.active : ''
              }`}
              onClick={() => {
                setItemActive(3);
                getClientHowItWorks();
              }}
            >
              <div className="d-flex align-items-center justify-content-center">
                <i className="material-icons-outlined fs-5 me-3 color-text">
                  contact_support
                </i>
                <span>Como funciona</span>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className={`p-3 mb-3 ${styles.tabItem}`} onClick={toggleModal}>
              <div className="d-flex align-items-center justify-content-center">
                <i className="material-icons-outlined me-3 fs-5 color-text">
                  inventory
                </i>
                <span>Privacidade</span>
              </div>
            </div>
          </div>
        </div>
        {/* fim Menu de opções */}
      </div>
      <div className="row">
        <div className="col-sm-12">
          {/* Renderização do conteúdo */}
          {itemActive === 1 && renderFaq()}
          {itemActive === 2 && (
            <div className="my-3">
              <Markup
                content={
                  isActiveSegmentationTerms && player.regional === 'sim'
                    ? termsContentSegmentation
                    : termsContent
                }
              />
            </div>
          )}
          {itemActive === 3 && renderHowItWorks()}
          <Modal open={modalIsOpen} onClose={toggleModal}>
            <div className="contents-modal">
              <h1 className="title-modal">Documentos importantes</h1>
              <p className="subtitle-modal">
                Acesse abaixo alguns documentos importantes da plataforma.
              </p>
              <List>
                <a
                  href="https://firebasestorage.googleapis.com/v0/b/oq20-139d9.appspot.com/o/TermsAndPolitics%2FPolitica_de_Privacidade_OQ_MIDIA_DIGITAL_JUNHO_2023.docx.pdf?alt=media&token=bd5c08bf-a482-4af6-8da7-408232e47893"
                  target="_blank"
                >
                  <ListItem icon="link" content="Políticas de privacidade" />
                </a>
                <a
                  href="https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/TermsAndPolitics%2FComunicação Violação de Dados_OQ DIGITAL.docx (1).pdf?alt=media&token=49390915-d267-4251-8dc8-473aaee1fda9"
                  target="_blank"
                >
                  <ListItem
                    icon="link"
                    content="Comunicação violação de dados"
                  />
                </a>
                <a
                  href="https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/TermsAndPolitics%2FBCR%20%20OQ%20DIGITAL.docx.pdf?alt=media&token=4ea9ee8b-1753-4f97-ae4c-13780464d76d"
                  target="_blank"
                >
                  <ListItem icon="link" content="BCR OQ Digital" />
                </a>
              </List>
            </div>
          </Modal>
          {/* fim Renderização do conteúdo */}
        </div>
      </div>
    </>
  );
}
